module.exports = __webpack_public_path__ + "static/media/rain-and-snow-mix.8857a969.svg";